module.exports = __webpack_public_path__ + "assets/img/preload_category_item.c0eb74f1.svg";